import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import Button from '../Button/index.js';

var Step = function Step(_ref) {
  var data = _ref.data,
    setCurrentStep = _ref.setCurrentStep,
    setIsLastStep = _ref.setIsLastStep,
    activeDot = _ref.activeDot,
    setActiveDot = _ref.setActiveDot,
    loadingStepValues = _ref.loadingStepValues,
    setLoadingStepValues = _ref.setLoadingStepValues,
    stepValues = _ref.stepValues,
    setStepValues = _ref.setStepValues;
  var goToStep = function goToStep(e, next, key, loading, link) {
    if (typeof link !== 'undefined') window.location = link;
    var value = e.currentTarget.value;
    setStepValues(_objectSpread2(_objectSpread2({}, stepValues), {}, _defineProperty({}, key, value)));
    setLoadingStepValues(_objectSpread2(_objectSpread2({}, loadingStepValues), {}, _defineProperty({}, value, _objectSpread2({}, loading))));

    // Used to increment the dot navigation
    setActiveDot(activeDot + 1);

    // Go to the next step that's defined in `StepsData.jsx` for the current step or else set isLastStep to true
    if (next === null) {
      setIsLastStep(true);
    } else {
      setCurrentStep(next);
    }
  };
  return data.map(function (_ref2) {
    var icon = _ref2.icon,
      text = _ref2.text,
      key = _ref2.key,
      value = _ref2.value,
      link = _ref2.link,
      next = _ref2.next,
      loading = _ref2.loading;
    return /*#__PURE__*/React.createElement("div", {
      className: "step-button-wrapper"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "leshen-mega-form-step-button",
      key: "".concat(key, "_").concat(text),
      onClick: function onClick(e) {
        return goToStep(e, next, key, loading, link);
      },
      variant: "mega",
      value: value,
      leftIcon: icon
    }, text));
  });
};
var Step$1 = Step;

export { Step$1 as default };
//# sourceMappingURL=Step.js.map
